import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

export const editedFlag = Symbol('edited');

export default function highlightEdited(CellRenderer) {
  function HighlightEditedWrapper(props) {
    const className = classnames({
      'data-edited': props.data[editedFlag],
    });

    return (
      <div className={className}>
        <CellRenderer {...props}/>
      </div>
    );
  }

  HighlightEditedWrapper.propTypes = {
    data: PropTypes.shape({
      [editedFlag]: PropTypes.bool,
    }).isRequired,
  };

  return HighlightEditedWrapper;
}
